module.exports = __webpack_public_path__ + "static/Heebo-VariableFont_wght-a1b47a80fe4b4a0d1f8df2c22ad089ba.woff";